import React, { useRef, useState, useEffect } from 'react';
import { DataTable, QuotationInfoCard } from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import { NumberFormat, MobileFormat, DateThaiFormat, DateFormat, DateThai, GetRole } from '../../Utils/Function';
import { createRoot } from 'react-dom/client';

import Swal from 'sweetalert2';
import API from '../../API';

import ProductCreate from './ProductCreate';
import ProductTypeCreate from './ProductTypeCreate';

import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/Horapa.css';

const PagProductList = () => {

    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _ProductTypeRef = useRef();
    const _ProductCreate = useRef();
    const _ProductTypeCreate = useRef();
    const [_GroupList, setGroupList] = useState([]);
    const [_PageMode, setPageMode] = useState(1);

    useEffect(() => {
        (async () => {
            await _LoadGroup();
        })();

        return () => { }
    }, []);
    const _LoadGroup = async () => {
        API({ method: "get", url: "/Search/Product/Type" }).then(res => {
            if (res.status !== 200) {
                return;
            }

            if (!res.data.Status) {
                return;
            }
            setGroupList(res.data.Data);
        }).catch(res => {
            return;
        });
    }

    const _configs = {
        "order": [[0, "asc"]],
        pageLength: 10,
        orderMulti: true
    }
    const _ajax = {
        'url': '/Product/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.ProductTypeID = getValues('ProductTypeID');
        }
    };

    const _Buttons = (d, r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _ProductCreate.current?.Show(d)}>Info</button>
            <button type='button' title='ลบ' className='btn btn-danger text-white' onClick={() => _DeleteProduct(d, r)}>ลบ</button>
        </div>
    )

    const _column = [
        { data: "ProductTypeName", name: "ProductTypeName", autoWidth: true },
        { data: "ProductName", name: "ProductName", autoWidth: true },
        { data: "Description", name: "Description", autoWidth: true },
        {
            data: "Price", name: "Price", autoWidth: true, render(data) {
                return NumberFormat(data);
            }
        },
        {
            data: "UpdateDate", name: "UpdateDate", autoWidth: true, render(data) {
                return DateFormat(data, true);
            }
        },
        {
            data: "ProductId", name: "ProductID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData, rowData) => createRoot(td).render(_Buttons(cellData, rowData))
        }
    ]

    const _ColumnDefs = []

    const _TypeConfigs = {
        "order": [[0, "asc"]],
        pageLength: 10,
        orderMulti: true
    }

    const _TypeAjax = {
        'url': '/Product/Type/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.ProductGroupID = getValues('ProductGroupID');
        }
    };

    const _TypeButtons = (d, r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => _ProductTypeCreate.current?.Show(d)}>Info</button>
            <button type='button' title='ลบ' className='btn btn-danger text-white' onClick={() => _DeleteProductType(d, r)}>ลบ</button>
        </div>
    )

    const _TypeColumn = [
        { data: "ProductTypeName", name: "ProductTypeName", autoWidth: true },
        { data: "Description", name: "Description", autoWidth: true },
        { data: "Remark", name: "Remark", autoWidth: true },
        {
            data: "UpdateDate", name: "UpdateDate", autoWidth: true, render(data) {
                return DateFormat(data, true);
            }
        },
        {
            data: "ProductTypeId", name: "ProductTypeId", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData, rowData) => createRoot(td).render(_TypeButtons(cellData, rowData))
        }
    ]

    const _DeleteProduct = async (ProductID, val) => {
        Swal.fire({
            icon: 'warning',
            title: 'ต้องลบสินค้า ' + val.ProductName + ' หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ลบ',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) {
                return;
            }
            API({ method: "delete", url: "/Product/" + ProductID }).then(res => {
                if (!res.data.Status) {
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                ref.current?.load();
            }).catch(res => {
                return;
            });
        });
    }
    
    const _DeleteProductType = async (ProductTypeID, val) => {
        Swal.fire({
            icon: 'warning',
            title: 'ต้องลบกลุ่มสินค้า ' + val.ProductTypeName + ' หรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ลบ',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) {
                return;
            }
            API({ method: "delete", url: "/Product/Type/" + ProductTypeID }).then(res => {
                if (!res.data.Status) {
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                _ProductTypeRef.current?.load();
            }).catch(res => {
                return;
            });
        });
    }
    return (
        <>
            <React.Fragment>
                <div className='container-fluid'>
                    <div className='row mt-4'>
                        <div className='col-lg-12'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h3 className='card-title'>จัดการสินค้า</h3>
                                </div>
                                <div className='card-body' style={{ 'minHeight': '300px' }}>
                                    <div className='row d-flex justify-content-end mb-4'>
                                        <div className='col-lg-3 text-end'>
                                            <div className='btn-group btn-group-sm'>
                                                <button type='button' disabled={(_PageMode === 1 ? true : false)} className={(_PageMode === 1 ? 'btn btn-secondary text-white active' : 'btn btn-primary text-white')} style={{ 'width': '120px' }} onClick={() => { setPageMode(1); }} >รายการสินค้า</button>
                                                <button type='button' disabled={(_PageMode === 2 ? true : false)} className={(_PageMode === 2 ? 'btn btn-secondary text-white active' : 'btn btn-primary text-white')} style={{ 'width': '120px' }} onClick={() => { setPageMode(2); }} >ประเภทสินค้า</button>
                                            </div>
                                        </div>
                                    </div>
                                    {(_PageMode === 1 ?
                                        <>
                                            <div className='row d-flex justify-content-end'>
                                                <div className='col-4 col-lg-3 mt-2 text-end'>
                                                    <div className="input-group mb-3">
                                                        <select className='form-control text-center' {...register("ProductTypeID", { required: false })} defaultValue={0}>
                                                            <option value={0} selected>ทั้งหมด</option>
                                                            {_GroupList.map((v, i) => {
                                                                return <option key={i} value={v.ProductTypeId}>{v.ProductTypeName}</option>
                                                            })}
                                                        </select>
                                                        <button type='button' style={{ 'width': '80px' }} className='btn btn-info text-white' onClick={() => ref.current.load()}>ค้นหา</button>
                                                        <button type='button' className='btn btn-primary text-white' onClick={() => { _ProductCreate.current?.Show(); }}>เพิ่มสินค้า</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-lg-12 table-responsive">
                                                    <table id="ProductListView" className='table w-100' role='grid'>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center textcenter">กลุ่ม</th>
                                                                <th className="text-center textcenter">สินค้า</th>
                                                                <th className="text-center textcenter">รายละเอียด</th>
                                                                <th className="text-center textright">ราคาต่อหน่วย</th>
                                                                <th className="text-center textcenter">วันที่แก้ไข</th>
                                                                <th className="text-center no-sort"></th>
                                                            </tr>
                                                        </thead>
                                                        <DataTable TableID={"ProductListView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                                    </table>
                                                </div>
                                            </div>
                                        </> : "")}
                                    {(_PageMode === 2 ?
                                        <>
                                            <div className='row d-flex justify-content-end'>
                                                <div className='col-4 col-lg-3 mt-2 text-end'>
                                                    <button type='button' className='btn btn-primary text-white' onClick={() => { _ProductTypeCreate.current?.Show(); }}>เพิ่มประเภทสินค้า</button>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-lg-12 table-responsive">
                                                    <table id="ProductTypeListView" className='table w-100' role='grid'>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center textcenter">ชื่อกลุ่ม</th>
                                                                <th className="text-center textcenter">รายละเอียด</th>
                                                                <th className="text-center textcenter">หมายเหตุ</th>
                                                                <th className="text-center textcenter">วันที่แก้ไข</th>
                                                                <th className="text-center no-sort"></th>
                                                            </tr>
                                                        </thead>
                                                        <DataTable TableID={"ProductTypeListView"} Column={_TypeColumn} Configs={_TypeConfigs} ref={_ProductTypeRef} ajax={_TypeAjax} ColumnDefs={_ColumnDefs} />
                                                    </table>
                                                </div>
                                            </div>
                                        </> : "")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ProductCreate ref={_ProductCreate} update={() => { ref.current?.load(); }} />
                <ProductTypeCreate ref={_ProductTypeCreate} update={() => { _ProductTypeRef.current?.load(); }} />
            </React.Fragment>
        </>
    )
}

export default React.memo(PagProductList)
